import clsx from 'clsx';
import { useBusinesses } from '../../Business';
import { Business } from '../../generated/graphql';
import { BusinessesTableContainer, BusinessesTableContainerProps } from './BusinessesTableContainer';
import { BusinessSumTableItem } from './BusinessSumTableItem';

interface PersonalFinancialStatementBusinessesTableProps
  extends Pick<BusinessesTableContainerProps, 'tableTitleClassName'> {
  householdID: string;
  onItemClicked?: (a: { business: Business }) => void;
}

export function PersonalFinancialStatementBusinessesTable({
  householdID,
  onItemClicked,
  tableTitleClassName,
}: PersonalFinancialStatementBusinessesTableProps) {
  const { businesses, businessesQuery } = useBusinesses({ householdID });

  return (
    <BusinessesTableContainer
      businessArray={Array.from(businesses || [])}
      isLoading={businessesQuery.isLoading}
      onItemClicked={onItemClicked}
      className="mb-4 md:mb-[47px] last:mb-6"
      tableRowsContainerClassName="mt-[2px]"
      tableTitleClassName={clsx(tableTitleClassName, 'sticky top-[56px] z-[1] bg-darkMode-gray-background')}
    >
      {({ business }) => (
        <BusinessSumTableItem
          key={business.id}
          business={business}
          onItemClicked={onItemClicked}
          className="focus:shadow-classic"
        />
      )}
    </BusinessesTableContainer>
  );
}
